import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
} from '@angular/core';
import { UIButton, UIFormModule } from '@shared/ui';
import { Router } from '@angular/router';
import { NzProgressComponent } from 'ng-zorro-antd/progress';
import { ISessionParking } from '@pkp/models';
import { SessionsService } from '@pkp/services';
import { LocalizationPipe } from '@shared/modules/localization';
import { createSessionProgress } from '../../../../shared/utils/session-progress';
import { PARKING_DETAILS_FROM_SESSIONS_STATE } from '../../../../shared/parking-details-page/parking-details-page.constants';

@Component({
  selector: 'pkp-d-session-box',
  templateUrl: 'session-box.component.html',
  styleUrls: ['session-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UIButton, UIFormModule, NzProgressComponent, LocalizationPipe],
})
export class SessionBoxComponent {
  private readonly sessionsService = inject(SessionsService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  session = input.required<ISessionParking>();

  interruptParkingModal = output<ISessionParking>();
  prolongParkingModal = output<ISessionParking>();

  protected readonly progress = createSessionProgress(
    this.session,
    this.sessionsService,
    this.destroyRef,
  );

  openParking(): void {
    this.router
      .navigate(['desktop', 'main', 'parking-details', this.session().parking.uuid], {
        state: { [PARKING_DETAILS_FROM_SESSIONS_STATE]: true },
      })
      .then();
  }
}
